import styled from 'styled-components';
import {device} from 'styled/device';

export const BookingInfoContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
  margin-bottom: 24px;
  @media (min-width: ${device.laptopM}) {
    gap: 0;
    display: flex;
    justify-content: space-between;
    max-width: 90%;
  }
  @media (min-width: ${device.laptopL}) {
    max-width: 100%;
  }
`;

export const BookingInfoItem = styled.div.attrs({className: 'home-booking-status-item'})<{
  width: string;
}>`
  width: ${props => props.width};
  &:not(:last-child) {
    border-right: solid 1px rgba(0, 0, 0, 0.1);
    @media (min-width: ${device.laptopM}) {
      border-right: none;
    }
  }
`;

export const BookingInfoTitle = styled.div.attrs({
  className: 'home-booking-status-title',
})`
  color: ${props => props.theme.colors.$p2};
  font-size: ${props => props.theme.fontSizes.$medium};
  font-weight: 400;
  line-height: 24px;
  @media (min-width: ${device.laptopM}) {
    text-align: center;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    margin-bottom: 16px;
  }
`;
export const BookingInfoText = styled.div.attrs({className: 'home-booking-status-text'})<{
  secondary?: boolean;
  center?: boolean;
  capitalize?: boolean;
}>`
  font-size: ${props =>
    props.secondary ? props.theme.fontSizes.$small : props.theme.fontSizes.$medium};
  color: ${props => props.theme.colors.$p10};
  font-weight: 400;
  line-height: 24px;
  text-align: ${props => (props.center ? 'center' : 'left')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  @media (min-width: ${device.laptopM}) {
    text-align: center;
    font-size: ${props =>
      props.secondary ? props.theme.fontSizes.$medium : props.theme.fontSizes.$largeXL};
    font-weight: 600;
    line-height: 20px; /* 90.909% */
    margin-bottom: ${props => (props.secondary ? '0px' : '8px')};
  }
`;
